function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 1.5,
  y1: 1.5,
  x2: 26.6111,
  y2: 1.5,
  stroke: "#23244D",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 1.5,
  y1: 12.5,
  x2: 26.6111,
  y2: 12.5,
  stroke: "#23244D",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 1.5,
  y1: 23.5,
  x2: 26.6111,
  y2: 23.5,
  stroke: "#23244D",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgBurgerMenuIcon = function SvgBurgerMenuIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurgerMenuIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burger-menu-icon.668036bc.svg";
export { ForwardRef as ReactComponent };